import { jsxs, jsx } from 'react/jsx-runtime';
import { PermissionRole } from '@fabric/woody-client';
import { useState } from 'react';
import * as yup from 'yup';
import { useMutationShareTokenCreate } from '../../mutations/useMutationShareTokenCreate.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { useInputControls } from '@fabric-app/hooks/useInputControls';
import { Flex } from '@fabric-app/ui/components/Flex';
import { TextInput } from '@fabric-app/ui/components/TextInput/TextInput';
import { SelectPermissionRole } from '../SelectPermissionRole.js';
import { Button } from '@fabric-app/ui/components/Button';

const InviteEmail = ({ resourceId, canGrantPermissions }) => {
  const mutationInviteByEmail = useMutationShareTokenCreate();
  const [parsedEmails, setParsedEmails] = useState([]);
  const [selectedRole, setSelectedRole] = useState(PermissionRole.VIEWER);
  const { isMobileView } = useResponsive();
  const inputControls = useInputControls("", {
    onChange: (value) => {
      setParsedEmails(value.split(",").map((email) => email.trim()).filter((item) => yup.string().email().isValidSync(item)));
    }
  });
  return /* @__PURE__ */ jsxs(Flex, {
    alignItems: "center",
    gap: "element",
    children: [
      /* @__PURE__ */ jsx(TextInput, {
        value: inputControls.value,
        onChange: inputControls.onChange,
        inputHeight: "xl",
        containerProps: {
          style: isMobileView ? {
            flexGrow: 1,
            paddingRight: 5
          } : {
            paddingRight: 7,
            flexGrow: 1
          }
        },
        disabled: canGrantPermissions === null,
        readOnly: mutationInviteByEmail.isPending,
        placeholder: "Email, comma separated",
        endAdornment: /* @__PURE__ */ jsx(SelectPermissionRole, {
          canGrantPermissions,
          onChange: setSelectedRole,
          value: selectedRole
        })
      }),
      /* @__PURE__ */ jsx(Button, {
        size: isMobileView ? "mobile-default" : "sm+",
        variant: "primary",
        isLoading: mutationInviteByEmail.isPending,
        disabled: parsedEmails.length === 0,
        onClick: () => {
          if (selectedRole !== "remove") {
            mutationInviteByEmail.mutate({
              resourceId,
              emails: parsedEmails,
              role: selectedRole
            }, {
              onSuccess: () => {
                setParsedEmails([]);
                inputControls.clear();
              }
            });
          }
        },
        children: "Invite"
      })
    ]
  });
};

export { InviteEmail };
//# sourceMappingURL=InviteEmail.js.map
